
document.createElement('tab-collection-slider');
class TabCollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.tab-item').forEach((item, idx) => {
      item.addEventListener('click', (event) => {
        if (!event.target.classList.contains('active')) this.update(idx);
      });
      if (Shopify.designMode) {
        item.addEventListener('shopify:block:select', (event) => {
          if (!event.target.classList.contains('active')) this.update(idx);
        });
      }
    });
    
    // this.resetWish(this.querySelector('.tab-container'));
  }
  

  update(idx) {
    this.querySelector('.tab-item.active').classList.remove('active');
    this.querySelectorAll('.tab-item')[idx].classList.add('active');
    this.querySelector('.tab-pane.active').classList.remove('active');
    this.querySelectorAll('.tab-pane')[idx].classList.add('active');
  }
  
  resetWish(proudctList) {
    proudctList.querySelectorAll('.flits-wishlist-colection').forEach((wishItem, idx)=> {
      wishItem.style = "";
    })
  }
}
window.customElements.define('tab-collection-slider', TabCollectionSlider);



/*联盟*/
 class AffiliateTabList extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.tabHeaders = this.querySelectorAll('.affiliate-tab-header');
    this.tabHeaders.forEach((tabHeader) => {
      tabHeader.addEventListener('click', this.tabClick.bind(tabHeader));
    });
  }
  tabClick() {
    console.log(this)
    var tabItem = this.closest('.affiliate-tab-item');
    if (!tabItem.classList.contains('active')) {
      tabItem.classList.add('active');
      this.querySelector('.icon').innerText = '-';
    } else {
      tabItem.classList.remove('active');
      this.querySelector('.icon').innerText = '+';
    }    
  }
}
customElements.define('affiliate-tab-list', AffiliateTabList);